/* ============================================================================
   DAILE custom — Кастомайзер, контроллер (TASK39 Ф0 → TASK44 срез 3).
   ТЗ: CUSTOMIZER_TZ_v3.md. Изолированный, НЕ трогает theme.js.
   Подключается только из sections/daile-customizer.liquid (defer, ПОСЛЕ
   daile-customizer-state.js — мост через window.DaileCustomizer).

   Сейчас умеет: 6 панелей по state.step, прогресс (пройденные кликабельны),
   Back/Continue в каждой панели, тумблер ориентации + свап мокапов
   (data-src-v/h — тем же механизмом свапаются и линии пазла), Шаг Upload:
   загрузка JPG/PNG + качество (ТЗ §5) + автоориентация (§4) + кроп
   drag/pinch/слайдер, Шаг Puzzle: то же фото в зоне-витрине + оверлей линий.

   Кроп в state — НОРМАЛИЗОВАННЫЙ (zoom + nx/ny в долях зоны): один и тот же
   кадр честно воспроизводится в зонах разного пиксельного размера (Upload,
   Puzzle, после — производственный скрипт). Во время жеста state не трогаем
   (60fps) — live-px напрямую, коммит нормализованного значения на отпускание.
   Жесты ТОЛЬКО на зоне Шага 0 (ТЗ Шаг 1: «возврат к Шагу 0 для замены/кропа»).
   ============================================================================ */
(function () {
  'use strict';

  /* DAILE custom (i18n): строки интерфейса приходят из snippets/daile-t.liquid
     через window.DAILE_T (см. sections/daile-customizer.liquid).
     Второй аргумент — английский фоллбек, если словарь не подключён. */
  var DT = (typeof window !== 'undefined' && window.DAILE_T) || {};
  function t(key, def) { return DT[key] || def; }


  /* ---------- аналитика (ТЗ §15): dataLayer, молча глотаем отсутствие ---------- */
  function track(eventName, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: eventName };
      for (var k in params) { if (params.hasOwnProperty(k)) payload[k] = params[k]; }
      window.dataLayer.push(payload);
    } catch (e) { /* аналитика не должна ломать UX */ }
    /* DAILE custom: Meta Pixel путь B — дублируем событие в Custom Pixel
       через Shopify.analytics.publish (window.fbq в основном документе нет).
       Отдельный try: publish не зависит от судьбы dataLayer-пуша. */
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(eventName, params || {});
      }
    } catch (e2) { /* аналитика не должна ронять кастомайзер */ }
  }

  /* ---------- качество печати (ТЗ §5 Шаг 0, пороги для 65×45 см) ----------
     Пороги в ТЗ даны как «длинная × короткая» сторона — сравниваем так же.
     'blocked' наружу не выходит — файл отклоняем. */
  function qualityLevel(w, h) {
    var long = Math.max(w, h);
    var short = Math.min(w, h);
    if (long < 800 || short < 600) return 'blocked';
    if (long > 3500 && short > 2500) return 'green';
    if (long >= 1500 && short >= 1000) return 'yellow';
    return 'red';
  }

  function croppedPhotoPixels(state) {
    if (!state.photo) return { width: 0, height: 0 };
    var width = state.orientation === 'h' ? 650 : 450;
    var height = state.orientation === 'h' ? 450 : 650;
    var zoom = Math.max(1, Number(state.crop && state.crop.zoom) || 1);
    var scale = Math.max((width + 5) / state.photo.width, (height + 5) / state.photo.height) * zoom;
    return { width: width / scale, height: height / scale };
  }

  function croppedQuality(state) {
    var pixels = croppedPhotoPixels(state);
    return qualityLevel(pixels.width, pixels.height);
  }

  function reconcileSubmission(shopRoot, lineId, submission) {
    if (submission.confirmed) return Promise.resolve(true);
    if (!submission.attempted) return Promise.resolve(false);
    return fetch(shopRoot + 'cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) throw new Error('cart verification failed');
        return response.json();
      })
      .then(function (cart) {
        if (!Array.isArray(cart.items)) throw new Error('cart verification failed');
        var matches = cart.items.filter(function (item) {
          var properties = item.properties || {};
          return properties._line_id === lineId || properties._parent_line === lineId;
        });
        if (!matches.length) {
          submission.attempted = false;
          return false;
        }
        var complete = matches.length === submission.items.length && submission.items.every(function (expected) {
          return matches.some(function (item) {
            var properties = item.properties || {};
            return Number(item.variant_id || item.id) === Number(expected.id) && item.quantity === expected.quantity &&
              Object.keys(expected.properties).every(function (key) { return properties[key] === expected.properties[key]; });
          });
        });
        if (!complete) throw new Error('cart verification incomplete');
        submission.confirmed = true;
        return true;
      })
      .catch(function (error) {
        var verificationError = new Error('cart verification failed');
        verificationError.cause = error;
        throw verificationError;
      });
  }

  function saveDesignAndAddItems(options, submission) {
    return reconcileSubmission(options.shopRoot, options.lineId, submission).then(function (alreadyAdded) {
      if (alreadyAdded) return;
      return fetch(options.configUrl, {
        method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: options.design
      }).catch(function (error) {
        var uploadError = new Error('upload config failed');
        uploadError.cause = error;
        throw uploadError;
      }).then(function (response) {
        if (!response.ok) throw new Error('upload config ' + response.status);
        submission.items = options.items;
        submission.attempted = true;
        return fetch(options.shopRoot + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: options.items })
        });
      }).then(function (response) {
        if (!response.ok) throw new Error('cart/add ' + response.status);
        submission.confirmed = true;
      });
    });
  }

  var QUALITY_TEXT = {
    green: t('js_q_green', 'Excellent quality — perfect for print.'),
    yellow: t('js_q_yellow', 'Good quality. For the very best result we recommend a higher-resolution photo.'),
    red: t('js_q_red', 'May look blurry at full print size. We recommend a better photo — you can continue at your own risk.'),
    blocked: t('js_err_crop', 'This crop is too small for print. Zoom out or upload a larger photo.')
  };

  function initCustomizer() {
    var root = document.querySelector('[data-daile-customizer]');
    if (!root || root.hasAttribute('data-daile-cz-inited')) return; // против двойной инициализации (аудит TASK49)
    root.setAttribute('data-daile-cz-inited', '');

    if (!window.DaileCustomizer) {
      console.error('[daile-customizer] state-модуль не загружен (daile-customizer-state.js должен идти первым)');
      return;
    }

    var store = window.DaileCustomizer.store;
    var STEPS = window.DaileCustomizer.STEPS;

    var panels = root.querySelectorAll('[data-daile-cz-panel]');
    var progressItems = root.querySelectorAll('[data-daile-cz-step]');
    var backBtns = root.querySelectorAll('[data-daile-cz-back]');
    var nextBtns = root.querySelectorAll('[data-daile-cz-next]');
    var orientBtns = root.querySelectorAll('[data-daile-cz-orient]');
    var mockups = root.querySelectorAll('[data-daile-cz-mockup]');

    // зоны фото: на Upload (жесты) и на Puzzle (витрина); фото-теги — во всех
    var zones = root.querySelectorAll('[data-daile-cz-zone]');
    var photoImgs = root.querySelectorAll('[data-daile-cz-photo]');
    var gestureZone = root.querySelector('[data-daile-cz-panel="upload"] [data-daile-cz-zone]');

    // upload-блок (панель Upload)
    var fileInput = root.querySelector('[data-daile-cz-file]');
    var dropzone = root.querySelector('[data-daile-cz-dropzone]');
    var uploadError = root.querySelector('[data-daile-cz-upload-error]');
    var photoControls = root.querySelector('[data-daile-cz-photo-controls]');
    var qualityEl = root.querySelector('[data-daile-cz-quality]');
    var zoomSlider = root.querySelector('[data-daile-cz-zoom]');
    var stage = root.querySelector('[data-daile-cz-stage]');

    // Шаг Box (TASK46, срез 4). TASK53: крышек стало две (превью Box +
    // мини-крышка в композиции Extras) — всё списками, рендер общий
    var lidImgs = root.querySelectorAll('[data-daile-cz-lid]');
    var lidCanvases = root.querySelectorAll('[data-daile-cz-lid-canvas]');
    var lidTexts = root.querySelectorAll('[data-daile-cz-lid-text]');
    var variantBtns = root.querySelectorAll('[data-daile-cz-variant]');
    var textControls = root.querySelector('[data-daile-cz-text-controls]');
    var textInput = root.querySelector('[data-daile-cz-text]');
    var fontBtns = root.querySelectorAll('[data-daile-cz-font]');
    var textSizeBtns = root.querySelectorAll('[data-daile-cz-textsize]');
    var colorBtns = root.querySelectorAll('[data-daile-cz-color]');

    // Шаг Card (TASK47, срез 5)
    var cardCanvas = root.querySelector('[data-daile-cz-card-canvas]');
    var cardText = root.querySelector('[data-daile-cz-card-text]');
    var cardTextSpan = root.querySelector('[data-daile-cz-card-text-span]');
    var cardToggles = root.querySelectorAll('[data-daile-cz-card-toggle]');
    var cardInput = root.querySelector('[data-daile-cz-card-input]');
    // TASK50: стиль текста карточки (как на Шаге 3) + confirm смены фото + моб. CTA
    var cardFontBtns = root.querySelectorAll('[data-daile-cz-card-font]');
    var cardAlignBtns = root.querySelectorAll('[data-daile-cz-card-align]'); // TASK79-фикс: группа не входила в styleBtns — кнопки оставались disabled
    var cardSizeBtns = root.querySelectorAll('[data-daile-cz-card-textsize]');
    var cardColorBtns = root.querySelectorAll('[data-daile-cz-card-color]');
    var confirmModal = root.querySelector('[data-daile-cz-confirm]');
    var confirmPending = null; // 'remove' | 'replace' — что подтверждаем
    var pendingReset = false;  // подтверждённый replace: сброс дизайна при приёме нового файла
    var nfcToggles = root.querySelectorAll('[data-daile-cz-nfc-toggle]');
    var nfcRow = root.querySelector('[data-daile-cz-nfc-row]');
    var nfcUrl = root.querySelector('[data-daile-cz-nfc-url]');
    var nfcError = root.querySelector('[data-daile-cz-nfc-error]');
    var nfcModal = root.querySelector('[data-daile-cz-nfc-modal]');
    var nfcVideo = nfcModal ? nfcModal.querySelector('video') : null;
    var boxNav = root.querySelector('[data-daile-cz-panel="box"] .daile-cz__nav');
    var boxControlsH = 0; // высота текст-контролов до скрытия (TASK48, компенсация под Continue)
    var cardHint = root.querySelector('[data-daile-cz-card-hint]');
    var cardCount = root.querySelector('[data-daile-cz-card-count]'); // TASK57: счётчик 300 симв.
    var lidCount = root.querySelector('[data-daile-cz-lid-count]');   // QA19: счётчик 80 симв. крышки

    // TASK97: 3D-сцена Review — клип-рамка крышки и её канвас
    var rvLid = root.querySelector('[data-daile-cz-rvlid]');
    var rvCanvas = root.querySelector('[data-daile-cz-review-canvas]');

    // TASK96-A: шаг Gift = подшаги Box lid / Greeting card (табы)
    var giftSubs = root.querySelectorAll('[data-daile-cz-gift-sub]');
    var giftTabBtns = root.querySelectorAll('[data-daile-cz-gift-tab]');
    var giftBadgeBox = root.querySelector('[data-daile-cz-gift-badge="box"]');
    var giftBadgeCard = root.querySelector('[data-daile-cz-gift-badge="card"]');
    var giftTab = 'box'; // активный подшаг; не в store — живёт сессию страницы

    // Шаг Extras (TASK49, срез 6)
    var extraBtns = root.querySelectorAll('[data-daile-cz-extra]');
    var frameBtn = root.querySelector('[data-daile-cz-frame]');
    var lbModal = root.querySelector('[data-daile-cz-lb]');
    var lbTitle = root.querySelector('[data-daile-cz-lb-title]');

    // Шаг Review (TASK49, срез 7)
    var rwOrient = root.querySelector('[data-daile-cz-rw-orient]');
    var rwBase = root.querySelector('[data-daile-cz-rw-base]');
    var rwBox = root.querySelector('[data-daile-cz-rw-box]');
    var rwBoxPrice = root.querySelector('[data-daile-cz-rw-box-price]');
    var rwBoxX = root.querySelector('[data-daile-cz-rw-remove="nodaile"]');
    var rwNfcRow = root.querySelector('[data-daile-cz-rw-nfc-row]');
    var rwNfc = root.querySelector('[data-daile-cz-rw-nfc]');
    var rwCardRow = root.querySelector('[data-daile-cz-rw-card-row]');
    var rwCard = root.querySelector('[data-daile-cz-rw-card]');
    var rwBagRow = root.querySelector('[data-daile-cz-rw-bag-row]');
    var rwMagnetsRow = root.querySelector('[data-daile-cz-rw-magnets-row]');
    var rwTotal = root.querySelector('[data-daile-cz-rw-total]');

    // TASK85: цены берутся из РЕАЛЬНЫХ товаров (Liquid кладёт центы в
    // data-daile-cz-prices, уже в валюте покупателя) — поменял цену в админке →
    // кастомайзер показывает новую. Константы ниже — только fallback.
    var PRICE_BASE = parseInt(root.getAttribute('data-daile-cz-base-price'), 10) || 100; // legacy, целые евро
    var PRICES = { nodaile: 6, card: 12, bag: 30, magnets: 60 }; // fallback (евро)
    var PRICES_CENTS = null;
    try { PRICES_CENTS = JSON.parse(root.getAttribute('data-daile-cz-prices') || 'null'); } catch (ePr) { PRICES_CENTS = null; }
    var CZ_CURRENCY = root.getAttribute('data-daile-cz-currency') || 'EUR';
    var CZ_LOCALE = root.getAttribute('data-daile-cz-locale') || 'en';
    function priceCents(key) {
      if (PRICES_CENTS && typeof PRICES_CENTS[key] === 'number') return PRICES_CENTS[key];
      if (key === 'base') return PRICE_BASE * 100;
      return (PRICES[key] || 0) * 100;
    }
    /* Зачёркнутый Review-итог: compare at price товаров (та же логика, что в дровере).
       «Полная» цена позиции = compare_at, если он выше обычной; иначе обычная. */
    var COMPARE_CENTS = null;
    try { COMPARE_CENTS = JSON.parse(root.getAttribute('data-daile-cz-compare') || 'null'); } catch (eCmp) { COMPARE_CENTS = null; }
    function comparePriceCents(key) {
      var cmp = (COMPARE_CENTS && typeof COMPARE_CENTS[key] === 'number') ? COMPARE_CENTS[key] : 0;
      var p = priceCents(key);
      return cmp > p ? cmp : p;
    }
    function fmtMoney(cents) {
      var amount = cents / 100;
      try {
        return new Intl.NumberFormat(CZ_LOCALE, {
          style: 'currency', currency: CZ_CURRENCY,
          minimumFractionDigits: (amount % 1 === 0 ? 0 : 2), maximumFractionDigits: 2
        }).format(amount);
      } catch (eFm) { return '€' + amount; } // страховка: старое поведение
    }

    // TASK54 (срез 8): варианты товаров и URL PDP из настроек секции
    var VIDS = {
      puzzle: root.getAttribute('data-daile-cz-vid-puzzle'),
      card: root.getAttribute('data-daile-cz-vid-card'),
      bag: root.getAttribute('data-daile-cz-vid-bag'),
      magnets: root.getAttribute('data-daile-cz-vid-magnets'),
      nologo: root.getAttribute('data-daile-cz-vid-nologo')
    };
    var PDP_URL = root.getAttribute('data-daile-cz-pdp-url') || '/products/custom-puzzle';
    var SHOP_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var atcError = root.querySelector('[data-daile-cz-atc-error]');
    var atcBusy = false;
    var submission = { attempted: false, confirmed: false, items: null };
    var lockedControls = null;

    /* TASK61 (срез 9, фронт): облачный хостинг фото. sessionLineId + photoToken
       живут одну сессию кастомайзера; оригинал грузится в фоне (со 2-го шага),
       превью — при Add to cart; URL с токеном кладём в _design (кросс-девайс
       Edit + постоянная миниатюра корзины). Read защищён токеном (Worker /photo). */
    // АУДИТ TASK62: дефолт-URL зашит и в JS — пустая настройка секции НЕ даёт
    // «заказ без облачной копии» (WORKER всегда определён).
    var WORKER_DEFAULT = 'https://daile-customizer-upload.hidden-surf-7be5.workers.dev';
    var WORKER = (root.getAttribute('data-daile-cz-worker') || WORKER_DEFAULT).replace(/\/$/, '');
    function randHex(n) {
      var a = new Uint8Array(n);
      (window.crypto || window.msCrypto).getRandomValues(a);
      var s = '';
      for (var i = 0; i < a.length; i++) s += ('0' + a[i].toString(16)).slice(-2);
      return s;
    }
    var sessionLineId = 'cz-' + Date.now().toString(36) + '-' + randHex(4); // crypto-хвост (аудит: не Math.random)
    var photoToken = randHex(16); // 32 hex-символа
    var uploadPromise = null;     // промис фоновой загрузки оригинала
    var uploadedForFile = null;   // какой File уже загружен (чтобы не грузить повторно)
    var uploadAbort = null;       // АУДИТ TASK62: отмена «висящего» PUT при смене фото
    function photoUrl(kind) {
      return WORKER + '/photo?line=' + sessionLineId + '&kind=' + kind + '&token=' + photoToken;
    }
    // АУДИТ TASK62 (критическая гонка): прервать фоновую загрузку прежнего фото,
    // чтобы её «поздний» PUT не перезаписал R2-ключ актуального фото.
    function abortUpload() {
      if (uploadAbort) { try { uploadAbort.abort(); } catch (e) { /* ok */ } uploadAbort = null; }
      uploadPromise = null;
    }

    // фоновая загрузка оригинала (идемпотентна: один и тот же File не грузит дважды)
    function uploadOriginal() {
      if (!WORKER || !currentFile) return Promise.resolve(false);
      if (uploadedForFile === currentFile) return Promise.resolve(true);
      if (uploadPromise && uploadPromise._file === currentFile) return uploadPromise;
      abortUpload(); // отменяем загрузку другого (прежнего) файла, если висит
      var file = currentFile;
      var ac = ('AbortController' in window) ? new AbortController() : null;
      uploadAbort = ac;
      var opts = { method: 'PUT', headers: { 'Content-Type': file.type }, body: file };
      if (ac) opts.signal = ac.signal;
      var p = fetch(WORKER + '/upload?line=' + sessionLineId + '&kind=original&token=' + photoToken, opts)
        .then(function (r) {
          if (!r.ok) throw new Error('upload original ' + r.status);
          uploadedForFile = file;
          if (uploadAbort === ac) uploadAbort = null;
          return true;
        }).catch(function (error) {
          if (uploadPromise === p) uploadPromise = null;
          if (uploadAbort === ac) uploadAbort = null;
          var saveError = new Error('upload original failed');
          saveError.cause = error;
          throw saveError;
        });
      p._file = file;
      uploadPromise = p;
      return p;
    }

    // превью (кроп клиента, ~180×260 JPEG) — генерим и грузим при Add to cart
    function uploadPreview() {
      if (!WORKER) return Promise.resolve(false);
      return new Promise(function (resolve) {
        var st = store.getState();
        var dataUrl = makeCartThumb(st);
        if (!dataUrl) { resolve(false); return; }
        fetch(dataUrl).then(function (r) { return r.blob(); }).then(function (blob) {
          return fetch(WORKER + '/upload?line=' + sessionLineId + '&kind=preview&token=' + photoToken, {
            method: 'PUT', headers: { 'Content-Type': 'image/jpeg' }, body: blob
          });
        }).then(function (r) {
          if (!r.ok) throw new Error('preview ' + r.status); // АУДИТ TASK62: fetch не бросает на 4xx/5xx
          resolve(true);
        })['catch'](function (e) {
          console.warn('[daile-customizer] preview upload', e); resolve(false);
        });
      });
    }

    var lbImg = root.querySelector('[data-daile-cz-lb-img]');
    if (lbImg) lbImg.addEventListener('load', function () {
      lbImg.width = lbImg.naturalWidth;
      lbImg.height = lbImg.naturalHeight;
    });
    var lbPh = root.querySelector('[data-daile-cz-lb-ph]');
    var lidNote = root.querySelector('[data-daile-cz-lid-note]');
    var sizeCopies = root.querySelectorAll('[data-daile-cz-size-copy]');
    var sizeFull = root.querySelector('[data-daile-cz-size-full]'); // TASK58: пилюля размера (см + дюймы)

    // TASK56: пометка жестов (мобайл), заметка interest-рамки, режим редактирования
    var gestureHint = root.querySelector('[data-daile-cz-gesture-hint]');
    var gestureHintDone = false;
    var frameNote = root.querySelector('[data-daile-cz-frame-note]');
    var editNote = root.querySelector('[data-daile-cz-edit-note]');
    var currentFile = null;   // исходный File фото — уходит в IndexedDB при Add to cart
    var editingLineId = null; // _line_id редактируемой строки корзины (?edit=...)

    window.addEventListener('pageshow', function (event) {
      if (!event.persisted || !submission.finished) return;
      editingLineId = sessionLineId;
      sessionLineId = 'cz-' + Date.now().toString(36) + '-' + randHex(4);
      photoToken = randHex(16);
      abortUpload();
      uploadedForFile = null;
      submission = { attempted: false, confirmed: false, items: null };
      atcBusy = false;
      setAtcBusyUi(false);
      render(store.getState());
    });

    function dismissGestureHint() {
      if (gestureHintDone) return;
      gestureHintDone = true;
      if (!gestureHint) return;
      gestureHint.classList.add('is-fading');
      window.setTimeout(function () { gestureHint.setAttribute('hidden', ''); }, 450);
    }

    /* TASK56: редактирование из корзины. Blob-URL фото умирает при переходе
       со страницы, поэтому оригинал храним в IndexedDB по _line_id — при
       ?edit= восстанавливаем дизайн из _design + фото из IndexedDB.
       Постоянное решение (кросс-девайс) придёт с CDN в срезе 9. */
    function idbOpen() {
      return new Promise(function (resolve, reject) {
        try {
          var rq = window.indexedDB.open('daile-cz', 1);
          rq.onupgradeneeded = function () { rq.result.createObjectStore('photos'); };
          rq.onsuccess = function () { resolve(rq.result); };
          rq.onerror = function () { reject(rq.error); };
        } catch (e) { reject(e); }
      });
    }
    function idbPut(key, val) {
      return idbOpen().then(function (db) {
        return new Promise(function (resolve, reject) {
          var tx = db.transaction('photos', 'readwrite');
          tx.objectStore('photos').put(val, key);
          tx.oncomplete = function () { resolve(); };
          tx.onerror = function () { reject(tx.error); };
        });
      });
    }
    function idbGet(key) {
      return idbOpen().then(function (db) {
        return new Promise(function (resolve, reject) {
          var rq = db.transaction('photos').objectStore('photos').get(key);
          rq.onsuccess = function () { resolve(rq.result || null); };
          rq.onerror = function () { reject(rq.error); };
        });
      });
    }

    /* TASK58: сохранение фото с запасным форматом — часть браузеров (Safari)
       капризничает с File в IndexedDB → повтор ArrayBuffer'ом; ошибки в консоль */
    function idbSavePhoto(lineId, file) {
      return idbPut('photo_' + lineId, file)
        .then(function () { console.log('[daile-customizer] фото сохранено для Edit (IndexedDB, File)'); })
        ['catch'](function (e1) {
          console.warn('[daile-customizer] File в IndexedDB не записался, пробую ArrayBuffer', e1);
          return new Promise(function (resolve) {
            var fr = new FileReader();
            fr.onload = function () {
              idbPut('photo_' + lineId, { buf: fr.result, type: file.type })
                .then(function () { console.log('[daile-customizer] фото сохранено для Edit (IndexedDB, ArrayBuffer)'); resolve(); })
                ['catch'](function (e2) { console.error('[daile-customizer] idb save (fallback)', e2); resolve(); });
            };
            fr.onerror = function () { console.error('[daile-customizer] FileReader', fr.error); resolve(); };
            fr.readAsArrayBuffer(file);
          });
        });
    }

    /* аудит TASK49: гейты должны действовать и на прыжки вперёд (прогресс/Edit),
       не только на Continue — иначе Review достижим без фото / с битым NFC */
    function maxAllowedStep(state) {
      if (!state.photo || croppedQuality(state) === 'blocked') return 0;
      // TASK96: индекс шага больше не хардкод — состав STEPS менялся дважды
      if (state.nfc.enabled && !validNfcUrl(state.nfc.url)) return STEPS.indexOf('gift');
      return STEPS.length - 1;
    }

    /* TASK50: подтверждённая смена фото сбрасывает весь дизайн (решение Никиты) */
    function designResetPatch() {
      return {
        box: { variant: 'default', position: 'center', text: '', font: 'cormorant', sizePreset: 'l', color: '#B4B4B4' },
        nfc: { enabled: false, url: '' },
        card: { added: false, text: '', font: 'cormorant', sizePreset: 'l', color: '#161514', align: 'justify' },
        extras: { bag: false, magnets: false, frameInterest: false },
        maxStepReached: 0,
        step: 0
      };
    }

    var MOCKUP_SPACE = 3919; // холст мокапа (ТЗ §7) — размер текста задаётся в нём
    var TEXT_MIN = 18;       // нижний порог читаемости (mockup-space)
    var FIT_MAX = 181;       // потолок автоподбора (TASK48: 145; TASK53: +25% — Small и Large крупнее)
    // TASK47: размер = автоподбор-до-влезания × пресет (заменил ползунок 40–80
    // из ТЗ §7): короткий текст крупный, длинный сам мельче, переполнение
    // невозможно. TASK48: осталось два пресета (решение Никиты) — Small =
    // бывший Medium, Large = максимум (потолок поднят на 20%).
    var SIZE_FACTORS = { s: 0.75, l: 1 };
    var FONT_STACKS = {
      cormorant: "'Cormorant Garamond', Georgia, serif",
      hanken: "'Hanken Grotesk', system-ui, sans-serif", // legacy: старые сохранённые дизайны
      // TASK78 п.6: новые шрифты текста (Hanken из UI выбора убран)
      poppins: "'Poppins', system-ui, sans-serif",
      bebas: "'Bebas Neue', sans-serif"
    };

    /* наибольший размер (в mockup-единицах), при котором span влезает в box —
       бинарный поиск по факту рендера; вернёт 0, если box скрыт */
    function fitUnits(span, box, canvasEl, cap) {
      var cw = canvasEl.clientWidth;
      if (!cw || !box.clientWidth) return 0;
      // TASK56: вписываем в КОНТЕНТ-бокс (clientWidth включает паддинги —
      // без вычета текст карточки долезал до самых краёв)
      var padX = 0, padY = 0;
      try {
        var cs = window.getComputedStyle(box);
        padX = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
        padY = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);
      } catch (e) { /* старые браузеры — без вычета */ }
      // TASK59: допуск +2px — scrollWidth целый (округляется ВВЕРХ),
      // а innerW дробный (процентные паддинги): без допуска проверка ширины
      // проваливалась на ЛЮБОМ размере → текст падал в TEXT_MIN (микротекст
      // на десктопе, скрины Никиты). QA17: по высоте допуска НЕТ — бокс с
      // overflow:hidden резал низ букв (нижние выносные Cormorant).
      var innerW = box.clientWidth - padX + 2;
      var innerH = box.clientHeight - padY;
      var scale = cw / MOCKUP_SPACE;
      var lo = TEXT_MIN, hi = cap, best = TEXT_MIN;
      for (var i = 0; i < 8; i++) {
        var mid = Math.round((lo + hi) / 2);
        span.style.fontSize = (mid * scale) + 'px';
        if (span.scrollWidth <= innerW && span.scrollHeight <= innerH) {
          best = mid; lo = mid + 1;
        } else {
          hi = mid - 1;
        }
        if (lo > hi) break;
      }
      return best;
    }

    var objectUrl = null; // текущий blob-URL (revoke при замене/удалении)
    var uploadSeq = 0;    // токен актуальности выбора файла (аудит TASK49: гонка probe.onload)

    /* ================= раскладка фото (cover × zoom, нормализованные offsets) ===== */
    var live = { zoom: 1, offsetX: 0, offsetY: 0 }; // px активного жеста (только gestureZone)
    var gesturing = false;

    /* Вылеты под обрез — bleed (TASK52). Печать пазла 455×655 мм при триме
       450×650 (2.5 мм/сторона — подтверждено Никитой). Фото ОБЯЗАНО покрывать
       зону + вылеты: min-zoom чуть выше «впритык» (~+1%, глазом незаметно),
       лимиты drag ужаты — превью показывает ровно trim-область, а срезаемые
       миллиметры существуют в оригинале. Print-скрипт (срез 9) экспортирует
       окно = видимая_зона × (1 + f) с тем же центром.
       Крышка/карточка: те же доли (кадр везде консистентен); точные вылеты их
       шаблонов уточнить у Никиты к срезу 9 (если больше — скрипт доскейлит). */
    var BLEED_SHORT = 5 / 450; // суммарные вылеты вдоль короткой стороны (450 мм)
    var BLEED_LONG = 5 / 650;  // вдоль длинной стороны (650 мм)

    function bleedFractions(z) {
      // TASK78 п.4: карточка тоже следует ориентации — при landscape фото на ней
      // лежит повёрнутым (ротатор), кадр считается по повёрнутой зоне
      var o = store.getState().orientation;
      return o === 'h'
        ? { fx: BLEED_LONG, fy: BLEED_SHORT }
        : { fx: BLEED_SHORT, fy: BLEED_LONG };
    }

    function layoutZone(z) {
      var st = store.getState();
      if (!st.photo) return;
      var img = z.querySelector('[data-daile-cz-photo]');
      if (!img) return;
      // TASK78 п.4: у карточки фото живёт в ротаторе — меряем его (portrait: = зона;
      // landscape: контейнер h×w + rotate90 в CSS)
      var box = z.querySelector('[data-daile-cz-card-rot]') || z;
      var zw = box.clientWidth;
      var zh = box.clientHeight;
      if (!zw || !zh) return; // панель скрыта — нечего считать

      var zoom, ox, oy;
      if (gesturing && z === gestureZone) { zoom = live.zoom; ox = live.offsetX; oy = live.offsetY; }
      else { zoom = st.crop.zoom; ox = st.crop.nx * zw; oy = st.crop.ny * zh; }

      // TASK52: покрываем зону + вылеты под обрез (см. BLEED_* выше)
      var bf = bleedFractions(z);
      var needW = zw * (1 + bf.fx);
      var needH = zh * (1 + bf.fy);
      var scale = Math.max(needW / st.photo.width, needH / st.photo.height) * zoom; // cover(+bleed) × zoom
      var dw = st.photo.width * scale;
      var dh = st.photo.height * scale;
      var maxX = Math.max(0, (dw - needW) / 2);
      var maxY = Math.max(0, (dh - needH) / 2);
      ox = Math.min(maxX, Math.max(-maxX, ox));
      oy = Math.min(maxY, Math.max(-maxY, oy));
      if (gesturing && z === gestureZone) { live.offsetX = ox; live.offsetY = oy; }

      img.style.width = dw + 'px';
      img.style.height = dh + 'px';
      img.style.left = ((zw - dw) / 2 + ox) + 'px';
      img.style.top = ((zh - dh) / 2 + oy) + 'px';
    }

    function layoutPhoto() {
      Array.prototype.forEach.call(zones, layoutZone);
      layoutReviewLid(); // TASK97: 3D-крышка на Review следует за раскладкой
    }

    /* ================= TASK97: 3D-крышка на Review =================
       Клип-рамка .daile-cz__rvlid (плоская крышка, полная композиция внутри)
       укладывается CSS-матрицей перспективы в 4 угла крышки коробки на
       review-мокапе. Углы — от Никиты, в долях холста 2508×2508 (порядок:
       верх-лев, верх-прав, низ-прав, низ-лев). */
    var RV_LID_CORNERS = {
      v: [[0.397129, 0.692584], [0.683413, 0.562201], [0.887959, 0.651914], [0.616826, 0.819378]],
      h: [[0.388756, 0.675837], [0.673844, 0.545853], [0.877592, 0.635566], [0.607656, 0.802233]]
    };

    /* Гомография «прямоугольник → произвольный четырёхугольник» через базисные
       матрицы (классическая схема adjugate, без библиотек). 3×3 row-major. */
    function rvAdj(m) {
      return [
        m[4] * m[8] - m[5] * m[7], m[2] * m[7] - m[1] * m[8], m[1] * m[5] - m[2] * m[4],
        m[5] * m[6] - m[3] * m[8], m[0] * m[8] - m[2] * m[6], m[2] * m[3] - m[0] * m[5],
        m[3] * m[7] - m[4] * m[6], m[1] * m[6] - m[0] * m[7], m[0] * m[4] - m[1] * m[3]
      ];
    }
    function rvMul(a, b) {
      var r = [], i, j, k, s;
      for (i = 0; i < 3; i++) {
        for (j = 0; j < 3; j++) {
          s = 0;
          for (k = 0; k < 3; k++) s += a[3 * i + k] * b[3 * k + j];
          r[3 * i + j] = s;
        }
      }
      return r;
    }
    function rvMulVec(m, v) {
      return [
        m[0] * v[0] + m[1] * v[1] + m[2] * v[2],
        m[3] * v[0] + m[4] * v[1] + m[5] * v[2],
        m[6] * v[0] + m[7] * v[1] + m[8] * v[2]
      ];
    }
    /* точки в порядке: (0,0)-угол, X-угол, Y-угол, диагональный */
    function rvBasis(p) {
      var m = [p[0][0], p[1][0], p[2][0], p[0][1], p[1][1], p[2][1], 1, 1, 1];
      var v = rvMulVec(rvAdj(m), [p[3][0], p[3][1], 1]);
      return rvMul(m, [v[0], 0, 0, 0, v[1], 0, 0, 0, v[2]]);
    }
    function rvProjection(w, h, to) {
      var src = rvBasis([[0, 0], [w, 0], [0, h], [w, h]]);
      var dst = rvBasis(to);
      var t = rvMul(dst, rvAdj(src));
      for (var i = 0; i < 9; i++) t[i] /= t[8];
      return t;
    }

    function layoutReviewLid() {
      if (!rvLid || !rvCanvas) return;
      var cw = rvCanvas.clientWidth;
      var ch = rvCanvas.clientHeight;
      var w = rvLid.offsetWidth;
      var h = rvLid.offsetHeight;
      if (!cw || !ch || !w || !h) return; // панель скрыта — нечего считать
      var pts = RV_LID_CORNERS[store.getState().orientation] || RV_LID_CORNERS.v;
      // порядок для базиса: TL, TR, BL, BR (диагональный последним)
      var to = [
        [pts[0][0] * cw, pts[0][1] * ch],
        [pts[1][0] * cw, pts[1][1] * ch],
        [pts[3][0] * cw, pts[3][1] * ch],
        [pts[2][0] * cw, pts[2][1] * ch]
      ];
      var t = rvProjection(w, h, to);
      rvLid.style.transform = 'matrix3d(' + [
        t[0], t[3], 0, t[6],
        t[1], t[4], 0, t[7],
        0, 0, 1, 0,
        t[2], t[5], 0, t[8]
      ].join(',') + ')';
      rvLid.style.visibility = 'visible'; // до первого расчёта скрыта (CSS)
    }

    function beginGesture() {
      if (gesturing) return;
      var st = store.getState();
      live.zoom = st.crop.zoom;
      live.offsetX = st.crop.nx * gestureZone.clientWidth;
      live.offsetY = st.crop.ny * gestureZone.clientHeight;
      gesturing = true;
    }

    function commitCrop() {
      var zw = gestureZone.clientWidth;
      var zh = gestureZone.clientHeight;
      gesturing = false;
      if (!zw || !zh) return;
      store.merge('crop', { zoom: live.zoom, nx: live.offsetX / zw, ny: live.offsetY / zh });
    }

    /* ================= приём файла ================= */
    function showError(msg) {
      if (!uploadError) return;
      if (msg) { uploadError.textContent = msg; uploadError.removeAttribute('hidden'); }
      else uploadError.setAttribute('hidden', '');
    }

    function setPhotoSrc(url, width, height) {
      Array.prototype.forEach.call(photoImgs, function (img) {
        img.width = width || 0;
        img.height = height || 0;
        if (url) img.setAttribute('src', url);
        else img.removeAttribute('src');
      });
    }

    /* keepDesign (TASK56): восстановление фото из IndexedDB в режиме
       редактирования — кроп/ориентация/дизайн уже в state, не трогаем */
    var MAX_PHOTO_MB = 60; // TASK98: должен совпадать с MAX_ORIGINAL_MB воркера

    function acceptFile(file, keepDesign) {
      if (!file) return;
      if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
        showError(t('js_err_format', 'Please upload a JPG or PNG photo.'));
        return;
      }
      // TASK98: понятный отказ сразу при выборе — раньше тяжёлый файл резался
      // воркером только на Add to cart («couldn’t save your photo»)
      if (file.size > MAX_PHOTO_MB * 1024 * 1024) {
        showError(t('js_err_big_1', 'This photo is over ') + MAX_PHOTO_MB + t('js_err_big_2', ' MB — please use a smaller file (JPG works best).'));
        return;
      }
      var url = URL.createObjectURL(file);
      var seq = ++uploadSeq; // выбор устарел (новый файл/Remove) → колбэк молча выходит
      var probe = new Image();
      probe.onload = function () {
        if (seq !== uploadSeq) { URL.revokeObjectURL(url); return; }
        var w = probe.naturalWidth;
        var h = probe.naturalHeight;
        var q = qualityLevel(w, h);
        if (q === 'blocked') {
          URL.revokeObjectURL(url);
          showError(t('js_err_small_1', 'This photo is too small for print (') + w + '×' + h + t('js_err_small_2', ' px). Please upload a larger one.'));
          track('photo_quality_warning', { level: 'blocked', width: w, height: h });
          return;
        }
        if (objectUrl) URL.revokeObjectURL(objectUrl); // заменяем предыдущее
        objectUrl = url;
        currentFile = file; // TASK56: оригинал — в IndexedDB при Add to cart
        abortUpload(); uploadedForFile = null; uploadPromise = null; // TASK61/62: новое фото → отменить прежнюю загрузку и перезалить
        showError(null);
        setPhotoSrc(url, w, h);
        var patch;
        if (keepDesign) {
          patch = { photo: { url: url, width: w, height: h, quality: q } };
        } else {
          // автоориентация (ТЗ §4); квадрат не трогает ручной выбор
          var orient = w > h ? 'h' : (h > w ? 'v' : store.getState().orientation);
          patch = {
            photo: { url: url, width: w, height: h, quality: q },
            crop: { zoom: 1, nx: 0, ny: 0 },
            orientation: orient
          };
          if (pendingReset) { // TASK50: подтверждённый replace — дизайн с нуля
            var resetP = designResetPatch();
            for (var rk in resetP) { if (resetP.hasOwnProperty(rk)) patch[rk] = resetP[rk]; }
            pendingReset = false;
          }
        }
        store.set(patch);
        if (keepDesign) {
          // edit-режим: всё восстановлено → сразу на Review
          store.set({ maxStepReached: STEPS.length - 1, step: STEPS.length - 1 });
        }
        track('photo_uploaded', { width: w, height: h, quality: q });
        if (q !== 'green') track('photo_quality_warning', { level: q, width: w, height: h });
      };
      probe.onerror = function () {
        URL.revokeObjectURL(url);
        if (seq !== uploadSeq) return;
        showError(t('js_err_read', 'We couldn’t read this file. Please try another photo.'));
      };
      probe.src = url;
    }

    function removePhoto() {
      uploadSeq++; // висящие probe.onload не «воскресят» фото после удаления
      if (objectUrl) { URL.revokeObjectURL(objectUrl); objectUrl = null; }
      currentFile = null;
      abortUpload(); uploadedForFile = null; uploadPromise = null; // TASK61/62
      setPhotoSrc(null);
      if (fileInput) fileInput.value = '';
      gesturing = false;
      showError(null);
      store.set({ photo: null, crop: { zoom: 1, nx: 0, ny: 0 } });
    }

    /* ================= жесты: drag = move, pinch = zoom (только Upload-зона) ===== */
    function initGestures() {
      if (!gestureZone || !window.PointerEvent) return; // без PointerEvent остаётся слайдер
      var pointers = {}; // id → {x,y}
      var count = 0;
      var startDist = 0;
      var startZoom = 1;

      function distance() {
        var ids = Object.keys(pointers);
        var a = pointers[ids[0]];
        var b = pointers[ids[1]];
        return Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2));
      }

      gestureZone.addEventListener('pointerdown', function (e) {
        if (!store.getState().photo) return;
        dismissGestureHint(); // TASK56: жест начат — пометка больше не нужна
        beginGesture();
        pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
        count++;
        if (count === 2) { startDist = distance(); startZoom = live.zoom; }
        try { gestureZone.setPointerCapture(e.pointerId); } catch (err) { /* iOS<13 */ }
        e.preventDefault();
      });

      gestureZone.addEventListener('pointermove', function (e) {
        var p = pointers[e.pointerId];
        if (!p) return;
        if (count === 1) {
          live.offsetX += e.clientX - p.x;
          live.offsetY += e.clientY - p.y;
        }
        p.x = e.clientX;
        p.y = e.clientY;
        if (count === 2 && startDist > 0) {
          live.zoom = Math.min(3, Math.max(1, startZoom * (distance() / startDist)));
        }
        layoutPhoto();
      });

      function release(e) {
        if (!pointers[e.pointerId]) return;
        delete pointers[e.pointerId];
        count = Math.max(0, count - 1);
        if (count < 2) startDist = 0;
        if (count === 0 && gesturing) commitCrop(); // жест кончился — фиксируем в state
      }
      gestureZone.addEventListener('pointerup', release);
      gestureZone.addEventListener('pointercancel', release);
    }

    /* ================= Шаг Box: крышка, текст (auto-shrink), NFC ================= */
    function validNfcUrl(u) { return /^https?:\/\/\S+\.\S+/.test((u || '').trim()); }

    function layoutLidText() {
      if (!lidTexts.length || !lidCanvases.length) return;
      var st = store.getState();
      var b = st.box;
      var show = !(b.variant === 'photo-only' || !b.text);
      Array.prototype.forEach.call(lidTexts, function (el) {
        if (show) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });
      if (!show) {
        if (lidNote) lidNote.setAttribute('hidden', '');
        return;
      }
      // текст и стиль — на все крышки (setProperty important — против The Seasons)
      Array.prototype.forEach.call(lidTexts, function (el) {
        var span = el.querySelector('[data-daile-cz-lid-text-span]');
        if (!span) return;
        span.textContent = b.text;
        span.style.setProperty('font-family', FONT_STACKS[b.font] || FONT_STACKS.cormorant, 'important');
        span.style.fontWeight = b.font === 'hanken' ? '500' : '400'; // TASK48/78: новые шрифты 400
        span.style.color = b.color;
      });
      // TASK53: units меряем ОДИН раз на первом видимом блоке (доли одинаковы),
      // затем применяем ко всем пропорционально ширине их холста
      var units = null;
      Array.prototype.forEach.call(lidCanvases, function (c) {
        var cw = c.clientWidth;
        if (!cw) return; // блок скрыт
        var box = c.querySelector('[data-daile-cz-lid-text]');
        var span = c.querySelector('[data-daile-cz-lid-text-span]');
        if (!box || !span) return;
        if (units === null) {
          var fitted = fitUnits(span, box, c, FIT_MAX);
          units = Math.max(TEXT_MIN, Math.round(fitted * (SIZE_FACTORS[b.sizePreset] || SIZE_FACTORS.s)));
          // мягкое предупреждение (ТЗ §5/§7): автоподбор упёрся в порог
          if (lidNote) {
            if (fitted <= TEXT_MIN + 2) lidNote.removeAttribute('hidden');
            else lidNote.setAttribute('hidden', '');
          }
        }
        span.style.fontSize = (units * (cw / MOCKUP_SPACE)) + 'px';
      });
      // финальный размер в mockup-единицах — производственному скрипту (срез 8/9)
      if (units !== null) {
        window.DaileCustomizer.derived = window.DaileCustomizer.derived || {};
        window.DaileCustomizer.derived.lidTextUnits = units;
      }
    }

    // TASK56/57/59: демо-послание на карточке, пока она не добавлена (превью-демо
    // по ТЗ); «призрак» (opacity .45). Текст правится в АДМИНКЕ: Customize →
    // страница Customizer → секция DAILE Customizer → «Card demo message».
    var CARD_SAMPLE = root.getAttribute('data-daile-cz-card-sample') ||
      'To someone special,\n\nEvery piece of this puzzle is a memory we share. Some took seconds, some took years — collect them slowly, smile often, and remember how far we have come.\n\nWith love, always';

    function layoutCardText() {
      if (!cardText || !cardTextSpan || !cardCanvas) return;
      var st = store.getState();
      var isSample = !st.card.added;
      var textVal = isSample ? CARD_SAMPLE : st.card.text;
      cardText.classList.toggle('is-sample', isSample);
      if (!textVal) { // карточка добавлена, но текст ещё не введён — чистая
        cardText.setAttribute('hidden', '');
        return;
      }
      cardText.removeAttribute('hidden');
      cardTextSpan.textContent = textVal;
      // TASK50: стиль текста карточки управляется клиентом; у примера — нейтральный
      var c = st.card;
      var fnt = isSample ? 'cormorant' : c.font;
      cardTextSpan.style.setProperty('font-family', FONT_STACKS[fnt] || FONT_STACKS.cormorant, 'important');
      cardTextSpan.style.fontWeight = fnt === 'hanken' ? '500' : '400'; // TASK78: poppins/bebas 400
      cardTextSpan.style.color = isSample ? '#161514' : c.color;
      // TASK78 п.5: позиционирование текста (left/center/right/justify)
      var alg = c.align || 'justify';
      cardTextSpan.style.textAlign = alg;
      cardTextSpan.style.textAlignLast = (alg === 'justify') ? 'center' : alg;
      var cw = cardCanvas.clientWidth;
      if (!cw) return;
      // TASK58: потолок = FIT_MAX как у крышки (был 100 — после block-режима
      // текста именно он давил размер на десктопе; Large «как было»)
      var fitted = fitUnits(cardTextSpan, cardText, cardCanvas, FIT_MAX);
      // TASK57: сэмпл — тем же пресетом Large, что и текст клиента по умолчанию
      var preset = isSample ? 'l' : c.sizePreset;
      var applied = Math.max(TEXT_MIN, Math.round(fitted * (SIZE_FACTORS[preset] || SIZE_FACTORS.s)));
      cardTextSpan.style.fontSize = (applied * (cw / MOCKUP_SPACE)) + 'px';
      if (!isSample) { // производству — только реальный текст клиента
        window.DaileCustomizer.derived = window.DaileCustomizer.derived || {};
        window.DaileCustomizer.derived.cardTextUnits = applied;
      }
    }

    function renderCard(state) {
      // TASK78 п.4: при landscape-пазле фото на карточке — повёрнутое (ротатор)
      var cardZoneEl = root.querySelector('.daile-cz__cardzone');
      if (cardZoneEl) cardZoneEl.classList.toggle('is-rot', state.orientation === 'h');
      Array.prototype.forEach.call(cardToggles, function (btn) {
        var on = btn.getAttribute('data-daile-cz-card-toggle') === 'on';
        btn.classList.toggle('is-on', on === state.card.added);
      });
      // поле видно всегда, активно только после «Добавить» (ТЗ §5 Шаг 3);
      // подсказка объясняет, почему поле заблокировано (TASK49)
      if (cardInput) {
        // TASK78 п.3: не disabled, а readonly+is-locked — заблокированное поле ловит
        // клик и подсказывает «сначала Add card» (nudge кнопки)
        if (state.card.added) { cardInput.removeAttribute('readonly'); cardInput.classList.remove('is-locked'); }
        else { cardInput.setAttribute('readonly', ''); cardInput.classList.add('is-locked'); }
        if (cardInput.value !== state.card.text) cardInput.value = state.card.text;
      }
      if (cardHint) {
        if (state.card.added) cardHint.setAttribute('hidden', '');
        else cardHint.removeAttribute('hidden');
      }
      // TASK57: счётчик оставшихся символов (лимит 300)
      if (cardCount) {
        if (state.card.added) {
          cardCount.textContent = Math.max(0, 300 - (state.card.text || '').length) + t('js_chars_left', ' characters left');
          cardCount.removeAttribute('hidden');
        } else {
          cardCount.setAttribute('hidden', '');
        }
      }
      // TASK50: контролы стиля активны только при добавленной карточке
      var styleBtns = [cardFontBtns, cardSizeBtns, cardColorBtns, cardAlignBtns]; // TASK79-фикс
      var attrs = ['data-daile-cz-card-font', 'data-daile-cz-card-textsize', 'data-daile-cz-card-color', 'data-daile-cz-card-align']; // TASK78 п.5
      var vals = [state.card.font, state.card.sizePreset, state.card.color, state.card.align || 'justify']; // TASK78
      for (var g = 0; g < styleBtns.length; g++) {
        Array.prototype.forEach.call(styleBtns[g], function (btn) {
          btn.classList.toggle('is-on', btn.getAttribute(attrs[g]) === vals[g]);
          if (state.card.added) btn.removeAttribute('disabled');
          else btn.setAttribute('disabled', '');
        });
      }
      layoutCardText();
    }

    function renderBox(state) {
      var b = state.box;
      // база крышки: default → лого вшито; photo-only / no-daile → чистая (ТЗ §3/§16);
      // TASK53: крышек несколько (Box + мини на Extras) — обновляем все
      var lidKind = b.variant === 'default' ? 'default' : 'nodaile';
      Array.prototype.forEach.call(lidImgs, function (im) {
        var src = im.getAttribute('data-src-' + state.orientation + '-' + lidKind);
        if (src && im.getAttribute('src') !== src) im.setAttribute('src', src);
      });
      Array.prototype.forEach.call(variantBtns, function (btn) {
        btn.classList.toggle('is-on', btn.getAttribute('data-daile-cz-variant') === b.variant);
      });
      // текст-контролы: у «Только фото» текста нет (ТЗ §3). TASK48: прячем
      // display:none, а высоту переносим в margin-bottom навигации — контролы
      // ниже подтягиваются вверх, пустота уходит ПОД Continue, футер стоит
      if (textControls) {
        var ghost = b.variant === 'photo-only';
        if (ghost && !textControls.hasAttribute('hidden')) {
          boxControlsH = textControls.offsetHeight; // замер до скрытия
        }
        if (ghost) textControls.setAttribute('hidden', '');
        else textControls.removeAttribute('hidden');
        if (boxNav) boxNav.style.marginBottom = ghost && boxControlsH ? boxControlsH + 'px' : '';
      }
      if (textInput && textInput.value !== b.text) textInput.value = b.text;
      // QA19: счётчик оставшихся символов крышки (лимит 80) — зеркало cardCount
      if (lidCount) {
        if (b.variant === 'photo-only') {
          lidCount.setAttribute('hidden', '');
        } else {
          lidCount.textContent = Math.max(0, 80 - (b.text || '').length) + t('js_chars_left', ' characters left');
          lidCount.removeAttribute('hidden');
        }
      }
      Array.prototype.forEach.call(fontBtns, function (btn) {
        btn.classList.toggle('is-on', btn.getAttribute('data-daile-cz-font') === b.font);
      });
      Array.prototype.forEach.call(textSizeBtns, function (btn) {
        btn.classList.toggle('is-on', btn.getAttribute('data-daile-cz-textsize') === b.sizePreset);
      });
      Array.prototype.forEach.call(colorBtns, function (btn) {
        btn.classList.toggle('is-on', btn.getAttribute('data-daile-cz-color') === b.color);
      });
      // позиция текстовой зоны: default / no-daile (у no-daile текст крупный, ТЗ §6)
      var tv = b.variant === 'no-daile' ? 'nodaile' : 'default';
      var lcls = 'daile-cz__lid-text daile-cz__lid-text--' + state.orientation + '-' + tv;
      Array.prototype.forEach.call(lidTexts, function (el) {
        if (el.className !== lcls) el.className = lcls;
      });
      // NFC (декуплен, ТЗ §5)
      Array.prototype.forEach.call(nfcToggles, function (btn) {
        var on = btn.getAttribute('data-daile-cz-nfc-toggle') === 'on';
        btn.classList.toggle('is-on', on === state.nfc.enabled);
      });
      if (nfcRow) {
        if (state.nfc.enabled) nfcRow.removeAttribute('hidden');
        else nfcRow.setAttribute('hidden', '');
      }
      if (nfcUrl && nfcUrl.value !== state.nfc.url) nfcUrl.value = state.nfc.url;
      if (nfcError) {
        var bad = state.nfc.enabled && state.nfc.url !== '' && !validNfcUrl(state.nfc.url);
        if (bad) nfcError.removeAttribute('hidden');
        else nfcError.setAttribute('hidden', '');
      }
      layoutLidText();
    }

    /* generic-модалки (TASK49): NFC-видео и лайтбокс апсейлов — один механизм */
    function openModal(m) {
      if (!m) return;
      var v = m.querySelector('video');
      if (v && !v.getAttribute('src') && v.getAttribute('data-src')) {
        v.setAttribute('src', v.getAttribute('data-src')); // ленивое видео
      }
      m.removeAttribute('hidden');
      if (v) { try { v.play().catch(function () {}); } catch (e) { /* автоплей запрещён — ок */ } }
    }

    function closeModal(m) {
      if (!m) return;
      m.setAttribute('hidden', '');
      var v = m.querySelector('video');
      if (v) { try { v.pause(); } catch (e) { /* не критично */ } }
    }

    /* ================= Шаги Extras и Review (TASK49, срезы 6–7) ================= */
    function renderExtras(state) {
      Array.prototype.forEach.call(extraBtns, function (btn) {
        var key = btn.getAttribute('data-daile-cz-extra');
        var on = !!state.extras[key];
        btn.classList.toggle('is-on', on);
        btn.textContent = on ? '✓ Added' : 'Add · ' + fmtMoney(priceCents(key)); // TASK85
      });
      if (frameBtn) {
        var interested = state.extras.frameInterest;
        frameBtn.classList.toggle('is-on', interested);
        frameBtn.textContent = interested ? '✓ On the list' : 'Notify me';
      }
      // TASK56: подтверждение — почта возьмётся из заказа (логика Никиты)
      if (frameNote) {
        if (state.extras.frameInterest) frameNote.removeAttribute('hidden');
        else frameNote.setAttribute('hidden', '');
      }
    }

    function renderReview(state) {
      if (!rwTotal) return;
      if (rwOrient) {
        rwOrient.textContent = state.orientation === 'h' ? t('js_orient_l', 'Landscape · 65 × 45 cm') : t('js_orient_p', 'Portrait · 45 × 65 cm');
      }
      // TASK85 + доработка: у цены пазла тоже зачёркнутая полная цена (compare at)
      if (rwBase) {
        var basePrice = priceCents('base');
        var baseFull = comparePriceCents('base');
        if (baseFull > basePrice) {
          rwBase.innerHTML = '<s class="daile-cz__price-compare">' + fmtMoney(baseFull) + '</s> ' + fmtMoney(basePrice);
        } else {
          rwBase.textContent = fmtMoney(basePrice);
        }
      }
      if (rwBox) {
        var names = {
          'default': t('js_lid_default', 'Photo, DAILE logo & your text'),
          'photo-only': t('js_lid_photo_only', 'Photo only'),
          'no-daile': t('js_lid_nologo', 'Photo & large text, no logo')
        };
        var boxLine = names[state.box.variant] || '';
        // аудит TASK49 (ТЗ §5 Шаг 5: «текст (если есть)») — цитата текста крышки
        if (state.box.variant !== 'photo-only' && state.box.text) {
          var lidMsg = state.box.text.replace(/\s+/g, ' ').trim();
          if (lidMsg) boxLine += ' · “' + (lidMsg.length > 26 ? lidMsg.slice(0, 26) + '…' : lidMsg) + '”';
        }
        rwBox.textContent = boxLine;
      }
      var noDaile = state.box.variant === 'no-daile';
      if (rwBoxPrice) { if (noDaile) rwBoxPrice.removeAttribute('hidden'); else rwBoxPrice.setAttribute('hidden', ''); }
      if (rwBoxX) { if (noDaile) rwBoxX.removeAttribute('hidden'); else rwBoxX.setAttribute('hidden', ''); }
      var hasNfc = state.nfc.enabled && validNfcUrl(state.nfc.url);
      if (rwNfcRow) { if (hasNfc) rwNfcRow.removeAttribute('hidden'); else rwNfcRow.setAttribute('hidden', ''); }
      if (rwNfc && hasNfc) rwNfc.textContent = state.nfc.url;
      if (rwCardRow) { if (state.card.added) rwCardRow.removeAttribute('hidden'); else rwCardRow.setAttribute('hidden', ''); }
      if (rwCard && state.card.added) {
        var msg = (state.card.text || '').replace(/\s+/g, ' ').trim();
        rwCard.textContent = msg ? '“' + (msg.length > 34 ? msg.slice(0, 34) + '…' : msg) + '”' : t('js_no_message', 'No message yet');
      }
      if (rwBagRow) { if (state.extras.bag) rwBagRow.removeAttribute('hidden'); else rwBagRow.setAttribute('hidden', ''); }
      if (rwMagnetsRow) { if (state.extras.magnets) rwMagnetsRow.removeAttribute('hidden'); else rwMagnetsRow.setAttribute('hidden', ''); }
      var total = priceCents('base') +
        (noDaile ? priceCents('nodaile') : 0) +
        (state.card.added ? priceCents('card') : 0) +
        (state.extras.bag ? priceCents('bag') : 0) +
        (state.extras.magnets ? priceCents('magnets') : 0);
      // Зачёркнутая полная цена рядом с итогом (compare at) — как Subtotal дровера
      var fullTotal = comparePriceCents('base') +
        (noDaile ? comparePriceCents('nodaile') : 0) +
        (state.card.added ? comparePriceCents('card') : 0) +
        (state.extras.bag ? comparePriceCents('bag') : 0) +
        (state.extras.magnets ? comparePriceCents('magnets') : 0);
      if (fullTotal > total) {
        rwTotal.innerHTML = '<s class="daile-cz__total-compare">' + fmtMoney(fullTotal) + '</s> ' + fmtMoney(total);
      } else {
        rwTotal.textContent = fmtMoney(total); // TASK85: центы + валюта покупателя
      }
    }

    /* ================= Add to cart (TASK54, срез 8; ТЗ §11/§12) =================
       Модель side cart (TASK30): пазл = основной line item с _line_id,
       апсейлы = дочерние товары с _parent_line. Вся конфигурация — в _design
       (JSON, скрытое поле «_»: не светится на чекауте, видно в админке заказа).
       Фото: URL ляжет в _design в срезе 9 (хостинг) — сейчас 'pending'. */
    function showAtcError(msg) {
      if (!atcError) return;
      if (msg) { atcError.textContent = msg; atcError.removeAttribute('hidden'); }
      else atcError.setAttribute('hidden', '');
    }

    /* TASK55: мини-превью кадра клиента (~180×260) для миниатюры в дровере.
       МАЛЕНЬКИЙ canvas — безопасно на мобиле (ТЗ §10.1 это явно разрешает);
       та же cover+bleed-математика, что в layoutZone. */
    function makeCartThumb(st) {
      try {
        if (!st.photo) return null;
        var srcImg = null;
        for (var i = 0; i < photoImgs.length; i++) {
          if (photoImgs[i].naturalWidth) { srcImg = photoImgs[i]; break; }
        }
        if (!srcImg) return null;
        var isH = st.orientation === 'h';
        var tw = isH ? 260 : 180;
        var th = isH ? 180 : 260;
        var bf = isH ? { fx: BLEED_LONG, fy: BLEED_SHORT } : { fx: BLEED_SHORT, fy: BLEED_LONG };
        var s = Math.max(tw * (1 + bf.fx) / st.photo.width, th * (1 + bf.fy) / st.photo.height) * st.crop.zoom;
        var sw = tw / s;
        var sh = th / s;
        var sx = (st.photo.width - sw) / 2 - (st.crop.nx * tw) / s;
        var sy = (st.photo.height - sh) / 2 - (st.crop.ny * th) / s;
        var cv = document.createElement('canvas');
        cv.width = tw;
        cv.height = th;
        cv.getContext('2d').drawImage(srcImg, sx, sy, sw, sh, 0, 0, tw, th);
        return cv.toDataURL('image/jpeg', 0.72);
      } catch (e) {
        return null; // canvas недоступен — останется фото товара, не критично
      }
    }

    function atcLabel() { // TASK56: в режиме редактирования — «Update in cart»
      return editingLineId ? t('js_update_cart', 'Update in cart') : t('js_add_cart', 'Add to cart');
    }

    function setAtcBusyUi(busy) {
      root.inert = busy;
      root.setAttribute('aria-busy', busy ? 'true' : 'false');
      if (busy && !lockedControls) {
        lockedControls = Array.prototype.map.call(root.querySelectorAll('button, input, textarea, select'), function (control) {
          var entry = { control: control, disabled: control.disabled };
          control.disabled = true;
          return entry;
        });
      }
      if (!busy && !submission.attempted && lockedControls) {
        lockedControls.forEach(function (entry) { entry.control.disabled = entry.disabled; });
        lockedControls = null;
      }
      Array.prototype.forEach.call(nextBtns, function (btn) {
        if (!btn.closest('[data-daile-cz-panel="review"]')) return;
        btn.textContent = busy ? t('js_adding', 'Adding…') : atcLabel();
        if (busy) btn.setAttribute('disabled', '');
        else btn.removeAttribute('disabled');
      });
    }

    /* TASK56: замена строки при редактировании — старый пазл и его дети
       удаляются ПОСЛЕ успешного добавления нового (не теряем дизайн при сбое) */
    function removeOldLine(oldId) {
      return fetch(SHOP_ROOT + 'cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
        .then(function (r) {
          if (!r.ok) throw new Error('cart verification failed');
          return r.json();
        })
        .then(function (c) {
          var updates = {};
          for (var i = 0; i < c.items.length; i++) {
            var p = c.items[i].properties || {};
            if (p._line_id === oldId || p._parent_line === oldId) updates[c.items[i].key] = 0;
          }
          if (!Object.keys(updates).length) return null;
          return fetch(SHOP_ROOT + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          }).then(function (response) {
            if (!response.ok) throw new Error('cart verification cleanup failed');
          });
        });
    }

    function addToCart() {
      if (atcBusy) return;
      var st = store.getState();
      if (maxAllowedStep(st) < STEPS.length - 1) {
        goTo(maxAllowedStep(st));
        return;
      }
      // конфиг магазина: выбранные апсейлы обязаны иметь назначенный товар
      var missing = [];
      if (!VIDS.puzzle) missing.push('puzzle');
      if (st.box.variant === 'no-daile' && !VIDS.nologo) missing.push('no-logo lid');
      if (st.card.added && !VIDS.card) missing.push('card');
      if (st.extras.bag && !VIDS.bag) missing.push('bag');
      if (st.extras.magnets && !VIDS.magnets) missing.push('magnets');
      if (missing.length) {
        console.error('[daile-customizer] missing products', missing);
        showAtcError(t('js_err_setup', 'This option is temporarily unavailable. Please try again later.'));
        return;
      }
      showAtcError(null);
      atcBusy = true;
      setAtcBusyUi(true);

      var lineId = sessionLineId; // TASK61: тот же id, под которым фото легло в облако
      var lidNames = { 'default': 'Default', 'photo-only': 'Photo only', 'no-daile': 'No logo' };

      // TASK61: гарантируем, что оригинал в облаке (фон мог не успеть / Edit-режим),
      // затем грузим превью. Заказ БЕЗ фото недопустим (ТЗ §11) → при провале
      // загрузки — понятная ошибка, без создания строки в корзине.
      var ensureCloud = uploadOriginal().then(function (ok) {
            if (!ok) throw new Error('cloud original upload failed');
            return uploadPreview();
          });

      ensureCloud.then(function (previewOk) {
        var props = {
          'Size': '1000 pieces',
          'Orientation': st.orientation === 'h' ? 'Landscape 65 × 45 cm' : 'Portrait 45 × 65 cm',
          'Lid': lidNames[st.box.variant] || 'Default'
        };
        if (st.box.variant !== 'photo-only' && st.box.text) props['Lid text'] = st.box.text;
        props['_line_id'] = lineId;
        if (st.nfc.enabled && st.nfc.url) props['_nfc_url'] = st.nfc.url; // «сырой» URL — скрыт (ТЗ §11)
        if (st.extras.bag) props['_cz_bag'] = 'yes'; // TASK55: дровер не предлагает сумку повторно
        // TASK56 (логика Никиты): интерес к рамке уходит В ЗАКАЗ — почта берётся
        // с чекаута; интерес без заказа остаётся только в аналитике (frame_interest)
        if (st.extras.frameInterest) props['_frame_interest'] = 'yes';
        var design = {
          v: 1,
          size: '1000',
          orientation: st.orientation,
          crop: st.crop, // zoom + nx/ny (нормализовано) — print-скрипт применит к оригиналу С ВЫЛЕТАМИ (TASK52)
          bleed: { short: 5 / 450, long: 5 / 650 }, // TASK62: те же доли вылетов, что в превью — для print-скрипта
          // TASK61: фото в облаке R2. line+token → чтение клиентом (Edit, миниатюра);
          // производство качает по line + STAFF_KEY (/file). URL с токеном лежат
          // в корзине клиента — чужие фото по перебору line недоступны.
          photo: st.photo ? {
            w: st.photo.width, h: st.photo.height, quality: croppedQuality(st),
            line: sessionLineId, token: photoToken,
            originalUrl: WORKER ? photoUrl('original') : null,
            previewUrl: (WORKER && previewOk) ? photoUrl('preview') : null // только если превью реально залилось
          } : null,
          box: st.box,
          card: st.card.added ? { text: st.card.text, font: st.card.font, sizePreset: st.card.sizePreset, color: st.card.color, align: st.card.align || 'justify' } : null, // TASK78: +align
          nfc: st.nfc.enabled ? st.nfc.url : null,
          extras: { bag: st.extras.bag, magnets: st.extras.magnets, frameInterest: st.extras.frameInterest }, // TASK55: полный конфиг (ТЗ §12)
          derived: window.DaileCustomizer.derived || {}
        };
        var designStr = JSON.stringify(design);
        props['_design'] = designStr;
        var items = [{ id: parseInt(VIDS.puzzle, 10), quantity: 1, properties: props }];
        if (st.box.variant === 'no-daile') {
          items.push({ id: parseInt(VIDS.nologo, 10), quantity: 1, properties: { '_parent_line': lineId } });
        }
        if (st.card.added) {
          items.push({ id: parseInt(VIDS.card, 10), quantity: 1, properties: { '_parent_line': lineId, 'Card message': st.card.text || '—' } });
        }
        if (st.extras.bag) {
          items.push({ id: parseInt(VIDS.bag, 10), quantity: 1, properties: { '_parent_line': lineId } });
        }
        if (st.extras.magnets) {
          items.push({ id: parseInt(VIDS.magnets, 10), quantity: 1, properties: { '_parent_line': lineId } });
        }

        track('add_to_cart_clicked', { items: items.length }); // ТЗ §15
        return saveDesignAndAddItems({
          shopRoot: SHOP_ROOT,
          lineId: lineId,
          configUrl: WORKER + '/upload?line=' + sessionLineId + '&kind=config&token=' + photoToken,
          design: designStr,
          items: items
        }, submission);
      })
        .then(function () {
          // TASK61: локальный fallback-thumb (мгновенная миниатюра до подгрузки
          // CDN-превью) + оригинал в IndexedDB (быстрый локальный Edit).
          try {
            var thumb = makeCartThumb(st);
            if (thumb) sessionStorage.setItem('daile_cz_preview_' + lineId, thumb);
          } catch (e) { /* quota/private mode — останется CDN-превью или фото товара */ }
          var saves = [];
          if (currentFile) saves.push(idbSavePhoto(lineId, currentFile));
          if (editingLineId) saves.push(removeOldLine(editingLineId));
          return Promise.all(saves);
        })
        .then(function () {
          // ТЗ §11: редирект на PDP кастом-пазла → авто-открытие side cart
          submission.finished = true;
          var glue = PDP_URL.indexOf('?') > -1 ? '&' : '?';
          window.location.href = PDP_URL + glue + 'daile_cart=open';
        })
        .catch(function (e) {
          console.error('[daile-customizer] add to cart', e);
          atcBusy = false;
          setAtcBusyUi(false);
          // TASK61: отдельный текст, если не удалось сохранить фото (заказ без
          // фото не создаём) — клиент повторит, дизайн не потерян
          var msg = submission.attempted || /cart verification/.test(e && e.message || '')
            ? t('js_err_cart_check', 'We couldn’t confirm your cart. Check your connection and try again — your design is still here.')
            : /upload/.test(e && e.message || '')
            ? t('js_err_save', 'We couldn’t save your photo — please check your connection and try again.')
            : t('js_err_generic', 'Something went wrong — please try again.');
          showAtcError(msg);
        });
    }

    /* ================= render: единственное место, где DOM догоняет state ==== */
    function render(state) {
      // панели: видима только текущая
      Array.prototype.forEach.call(panels, function (panel) {
        var id = panel.getAttribute('data-daile-cz-panel');
        if (STEPS.indexOf(id) === state.step) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });

      // прогресс: is-current / is-done (done = досягаемые, по ним можно ходить);
      // аудит TASK49: досягаемость клампится гейтами (нет фото / битый NFC URL)
      var reach = Math.min(state.maxStepReached, maxAllowedStep(state));
      Array.prototype.forEach.call(progressItems, function (btn) {
        var idx = parseInt(btn.getAttribute('data-daile-cz-step'), 10);
        var li = btn.closest('li');
        if (!li) return;
        li.classList.toggle('is-current', idx === state.step);
        li.classList.toggle('is-done', idx !== state.step && idx <= reach);
        if (idx === state.step) btn.setAttribute('aria-current', 'step');
        else btn.removeAttribute('aria-current');
      });

      // копирайты с размером пазла следуют ориентации (аудит TASK49)
      Array.prototype.forEach.call(sizeCopies, function (el) {
        el.textContent = state.orientation === 'h' ? t('js_size_h_short', '65 × 45 cm') : t('js_size_v_short', '45 × 65 cm');
      });
      if (sizeFull) { // TASK58: пилюля размера
        sizeFull.textContent = state.orientation === 'h' ? t('js_size_h', '65 × 45 cm · 26 × 18 in') : t('js_size_v', '45 × 65 cm · 18 × 26 in');
      }

      // Back скрыт на первом шаге
      Array.prototype.forEach.call(backBtns, function (btn) {
        if (state.step === 0) btn.setAttribute('hidden', '');
        else btn.removeAttribute('hidden');
      });

      // Continue: на Upload заблокирована без фото; на Box — при включённом NFC
      // с невалидным URL; на Review = живая Add to cart (TASK54, срез 8)
      var last = state.step === STEPS.length - 1;
      var uploadGate = state.step === 0 && (!state.photo || croppedQuality(state) === 'blocked');
      var nfcGate = state.step === STEPS.indexOf('gift') && state.nfc.enabled && !validNfcUrl(state.nfc.url); // TASK96: гейт держит весь шаг Gift (оба подшага)
      Array.prototype.forEach.call(nextBtns, function (btn) {
        btn.textContent = last ? (atcBusy ? t('js_adding', 'Adding…') : atcLabel()) : t('js_continue', 'Continue');
        if (uploadGate || nfcGate || (last && atcBusy)) btn.setAttribute('disabled', '');
        else btn.removeAttribute('disabled');
      });

      // тумблер ориентации
      Array.prototype.forEach.call(orientBtns, function (btn) {
        btn.classList.toggle('is-on', btn.getAttribute('data-daile-cz-orient') === state.orientation);
      });

      // ориентация на корне (для возможных CSS-хуков)
      root.classList.toggle('daile-cz--v', state.orientation === 'v');
      root.classList.toggle('daile-cz--h', state.orientation === 'h');

      // мокапы и линии: свап по ориентации (data-src-v / data-src-h)
      Array.prototype.forEach.call(mockups, function (img) {
        var src = img.getAttribute('data-src-' + state.orientation);
        if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
      });

      // upload-блок: дроп-зона ↔ контролы фото
      if (dropzone && photoControls) {
        if (state.photo) {
          dropzone.setAttribute('hidden', '');
          photoControls.removeAttribute('hidden');
          if (qualityEl) {
            var quality = croppedQuality(state);
            qualityEl.textContent = QUALITY_TEXT[quality] || '';
            qualityEl.className = 'daile-cz__quality is-' + (quality === 'blocked' ? 'red' : quality);
          }
        } else {
          dropzone.removeAttribute('hidden');
          photoControls.setAttribute('hidden', '');
        }
      }

      // TASK56: пометка «жесты прямо тут» (мобайл, до первого жеста);
      // заметка edit-режима гаснет, как только фото на месте
      if (gestureHint && !gestureHintDone) {
        if (state.step === 0 && state.photo) gestureHint.removeAttribute('hidden');
        else gestureHint.setAttribute('hidden', '');
      }
      if (editNote && state.photo) editNote.setAttribute('hidden', '');

      // зоны фото: пазл — по ориентации; крышка — вариант+ориентация (TASK46);
      // пустая на Upload = кликабельный призыв (TASK42)
      Array.prototype.forEach.call(zones, function (z) {
        var cls = 'daile-cz__zone';
        var zoneKind = z.getAttribute('data-zone-kind');
        if (zoneKind === 'lid') {
          var vc = state.box.variant === 'photo-only' ? 'photoonly' : 'default'; // no-daile: фото-зона = default (ТЗ §6)
          cls += ' daile-cz__lidzone--' + state.orientation + '-' + vc;
        } else if (zoneKind === 'card') {
          cls += ' daile-cz__cardzone'; // карточка одна, ориентация не влияет (TASK47)
        } else if (zoneKind === 'review') {
          cls += ' daile-cz__rvzone--' + state.orientation; // TASK97: зона пазла на review-холсте
        } else {
          cls += ' daile-cz__zone--' + state.orientation;
          if (!state.photo) cls += ' is-empty';
        }
        if (z.hasAttribute('data-daile-cz-static')) cls += ' daile-cz__zone--static';
        if (z.className !== cls) z.className = cls;
      });

      // TASK96-A: подшаги Gift — видимость по giftTab, табы, бейджи состояния
      Array.prototype.forEach.call(giftSubs, function (el) {
        if (el.getAttribute('data-daile-cz-gift-sub') === giftTab) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });
      Array.prototype.forEach.call(giftTabBtns, function (btn) {
        var v = btn.getAttribute('data-daile-cz-gift-tab');
        btn.classList.toggle('is-on', v === giftTab);
        btn.setAttribute('aria-selected', v === giftTab ? 'true' : 'false');
      });
      var boxTouched = state.box.variant !== 'default' || !!(state.box.text && state.box.text.trim()) || state.nfc.enabled;
      if (giftBadgeBox) giftBadgeBox.hidden = !boxTouched;
      if (giftBadgeCard) giftBadgeCard.hidden = !state.card.added;

      renderBox(state);
      renderCard(state);
      renderExtras(state);
      renderReview(state);

      // слайдер синхронизируем со state (вне жеста)
      if (zoomSlider && !gesturing) zoomSlider.value = Math.round(state.crop.zoom * 100);

      layoutPhoto(); // в конце — активная панель уже видима, размеры зоны актуальны
    }

    var reviewTracked = false; // review_reached — один раз за сессию (аудит: повторные входы завышали воронку)

    /* TASK96-A: смена подшага Gift (Box lid ↔ Greeting card) */
    function setGiftTab(v) {
      if (v !== 'box' && v !== 'card') return;
      if (v === giftTab) return;
      giftTab = v;
      render(store.getState());
    }

    function goTo(idx) {
      var state = store.getState();
      idx = Math.min(idx, maxAllowedStep(state)); // гейты действуют на ЛЮБОЙ переход вперёд
      if (idx === state.step || idx < 0 || idx >= STEPS.length) return;
      // TASK96-A: вход на Gift движением вперёд — всегда с подшага Box lid
      // (goto из Review может предварительно выставить giftTab='card' — тогда
      // idx ниже текущего шага и сброс не сработает, что и нужно)
      if (STEPS[idx] === 'gift' && idx > state.step) giftTab = 'box';
      // TASK61: уходим с шага Upload вперёд с готовым фото → старт фоновой загрузки
      // (решение Никиты: не с 1-го шага — минимум «сирот»; к Review обычно готово)
      if (state.step === 0 && idx > 0 && state.photo && currentFile) {
        uploadOriginal()['catch'](function (e) { console.warn('[daile-customizer] bg upload', e); });
      }
      store.set({
        step: idx,
        maxStepReached: Math.max(state.maxStepReached, idx)
      });
      if (idx === STEPS.length - 1 && !reviewTracked) { reviewTracked = true; track('review_reached', {}); } // ТЗ §15
      // после смены шага возвращаем клиента к началу сцены
      try { root.scrollIntoView({ block: 'start', behavior: 'smooth' }); } catch (e) { /* старые браузеры */ }
    }

    /* ---------- wiring (делегирование на стабильном root) ---------- */
    root.addEventListener('click', function (e) {
      var next = e.target.closest('[data-daile-cz-next]');
      if (next && !next.disabled) {
        var s = store.getState();
        if (s.step === STEPS.length - 1) { addToCart(); return; } // Review → корзина (TASK54)
        // TASK96-A: Continue-прогрессия внутри Gift — Box lid → Greeting card,
        // второй Continue ведёт дальше: карточку нельзя пролистнуть не заметив
        if (STEPS[s.step] === 'gift' && giftTab === 'box') {
          setGiftTab('card');
          try { root.scrollIntoView({ block: 'start', behavior: 'smooth' }); } catch (eSc) { /* старые браузеры */ }
          return;
        }
        track('step_completed', { step: STEPS[s.step], step_index: s.step + 1 });
        goTo(s.step + 1);
        return;
      }
      var back = e.target.closest('[data-daile-cz-back]');
      if (back) {
        var sb = store.getState();
        // TASK96-A: Back внутри Gift: с карточки — на крышку; с Review — на карточку
        if (STEPS[sb.step] === 'gift' && giftTab === 'card') { setGiftTab('box'); return; }
        if (STEPS[sb.step - 1] === 'gift') giftTab = 'card';
        goTo(sb.step - 1);
        return;
      }
      var giftTabBtn = e.target.closest('[data-daile-cz-gift-tab]');
      if (giftTabBtn) { setGiftTab(giftTabBtn.getAttribute('data-daile-cz-gift-tab')); return; }

      var orient = e.target.closest('[data-daile-cz-orient]');
      if (orient) {
        var val = orient.getAttribute('data-daile-cz-orient');
        if (val !== store.getState().orientation) {
          // смена ориентации = другая зона → кроп с нуля (кадр прежней зоны не валиден)
          store.set({ orientation: val, crop: { zoom: 1, nx: 0, ny: 0 } });
        }
        return;
      }

      var browse = e.target.closest('[data-daile-cz-browse]');
      if (browse && fileInput) {
        var bst = store.getState();
        // TASK50: дизайн уже начат → подтверждение (replace = сброс шагов)
        if (bst.photo && bst.maxStepReached > 0) { confirmPending = 'replace'; openModal(confirmModal); }
        else fileInput.click();
        return;
      }

      // TASK42: пустая зона на мокапе = кнопка выбора файла
      var zoneClick = e.target.closest('[data-daile-cz-zone]');
      if (zoneClick && !store.getState().photo && fileInput) { fileInput.click(); return; }

      var remove = e.target.closest('[data-daile-cz-remove]');
      if (remove) {
        // TASK50: дизайн уже начат → подтверждение (remove = сброс шагов)
        if (store.getState().maxStepReached > 0) { confirmPending = 'remove'; openModal(confirmModal); }
        else removePhoto();
        return;
      }

      // confirm-модалка смены фото (TASK50)
      var cyes = e.target.closest('[data-daile-cz-confirm-yes]');
      if (cyes) {
        closeModal(confirmModal);
        if (confirmPending === 'remove') { removePhoto(); store.set(designResetPatch()); }
        else if (confirmPending === 'replace') { pendingReset = true; if (fileInput) fileInput.click(); }
        confirmPending = null;
        return;
      }
      var cno = e.target.closest('[data-daile-cz-confirm-no]');
      if (cno) { closeModal(confirmModal); confirmPending = null; return; }

      // стиль текста карточки (TASK50; disabled-кнопки клик не шлют)
      var cfont = e.target.closest('[data-daile-cz-card-font]');
      if (cfont) { store.merge('card', { font: cfont.getAttribute('data-daile-cz-card-font') }); return; }
      var calign = e.target.closest('[data-daile-cz-card-align]'); // TASK78 п.5
      if (calign) { store.merge('card', { align: calign.getAttribute('data-daile-cz-card-align') }); return; }
      var csize = e.target.closest('[data-daile-cz-card-textsize]');
      if (csize) { store.merge('card', { sizePreset: csize.getAttribute('data-daile-cz-card-textsize') }); return; }
      var ccolor = e.target.closest('[data-daile-cz-card-color]');
      if (ccolor) { store.merge('card', { color: ccolor.getAttribute('data-daile-cz-card-color') }); return; }

      // Шаг Box (TASK46)
      var variant = e.target.closest('[data-daile-cz-variant]');
      if (variant) {
        var v = variant.getAttribute('data-daile-cz-variant');
        if (v !== store.getState().box.variant) {
          store.merge('box', { variant: v });
          track('composition_type_selected', { type: v });
        }
        return;
      }
      var font = e.target.closest('[data-daile-cz-font]');
      if (font) { store.merge('box', { font: font.getAttribute('data-daile-cz-font') }); return; }
      var tsize = e.target.closest('[data-daile-cz-textsize]');
      if (tsize) { store.merge('box', { sizePreset: tsize.getAttribute('data-daile-cz-textsize') }); return; }
      var cardT = e.target.closest('[data-daile-cz-card-toggle]');
      if (cardT) {
        var addCard = cardT.getAttribute('data-daile-cz-card-toggle') === 'on';
        if (addCard !== store.getState().card.added) {
          store.merge('card', { added: addCard });
          track(addCard ? 'card_added' : 'card_removed', {});
          // TASK49: включили карточку → сразу в поле сообщения
          if (addCard && cardInput) { try { cardInput.focus(); } catch (err) { /* не критично */ } }
        }
        return;
      }

      // Шаг Extras (TASK49)
      var extra = e.target.closest('[data-daile-cz-extra]');
      if (extra) {
        var exKey = extra.getAttribute('data-daile-cz-extra');
        var exOn = !store.getState().extras[exKey];
        var patch = {};
        patch[exKey] = exOn;
        store.merge('extras', patch);
        if (exOn) track(exKey + '_added', {}); // bag_added / magnets_added (ТЗ §15)
        return;
      }
      var frame = e.target.closest('[data-daile-cz-frame]');
      if (frame) {
        // QA23: честный тоггл — повторный клик снимает интерес;
        // сигнал шлём ТОЛЬКО при включении (interest-signal, ТЗ §9)
        var frOn = !store.getState().extras.frameInterest;
        store.merge('extras', { frameInterest: frOn });
        if (frOn) track('frame_interest', {});
        return;
      }
      var lb = e.target.closest('[data-daile-cz-lightbox]');
      if (lb) {
        if (lbTitle) lbTitle.textContent = lb.getAttribute('data-title') || '';
        // фото продукта: data-full на кнопке-окошке → картинка; нет — плейсхолдер
        var full = lb.getAttribute('data-full');
        if (lbImg) {
          if (full) { lbImg.setAttribute('src', full); lbImg.removeAttribute('hidden'); }
          else lbImg.setAttribute('hidden', '');
        }
        if (lbPh) {
          if (full) lbPh.setAttribute('hidden', '');
          else lbPh.removeAttribute('hidden');
        }
        openModal(lbModal);
        return;
      }
      var lbClose = e.target.closest('[data-daile-cz-lb-close]');
      if (lbClose) { closeModal(lbModal); return; }

      // Шаг Review (TASK49): × убирает апсейл, Edit ведёт на его шаг
      var rwRemove = e.target.closest('[data-daile-cz-rw-remove]');
      if (rwRemove) {
        var what = rwRemove.getAttribute('data-daile-cz-rw-remove');
        // события — те же, что на родных шагах (аудит: data layer не должен расходиться)
        if (what === 'card') { store.merge('card', { added: false }); track('card_removed', {}); }
        else if (what === 'bag') { store.merge('extras', { bag: false }); }
        else if (what === 'magnets') { store.merge('extras', { magnets: false }); }
        else if (what === 'nodaile') { store.merge('box', { variant: 'default' }); track('composition_type_selected', { type: 'default' }); }
        else if (what === 'nfc') { store.merge('nfc', { enabled: false }); track('nfc_selected', { enabled: false }); }
        return;
      }
      var gotoBtn = e.target.closest('[data-daile-cz-goto]');
      if (gotoBtn) {
        // TASK96-A: goto по ИМЕНИ шага (+ опциональный подшаг Gift через двоеточие:
        // "gift:card") — индексы дважды ломались при перестройке STEPS
        var gotoParts = String(gotoBtn.getAttribute('data-daile-cz-goto')).split(':');
        var gotoIdx = STEPS.indexOf(gotoParts[0]);
        var gs = store.getState();
        if (gotoIdx >= 0 && gotoIdx <= Math.min(gs.maxStepReached, maxAllowedStep(gs))) {
          if (gotoParts[1]) giftTab = gotoParts[1];
          goTo(gotoIdx);
        }
        return;
      }
      var color = e.target.closest('[data-daile-cz-color]');
      if (color) { store.merge('box', { color: color.getAttribute('data-daile-cz-color') }); return; }
      var nfcT = e.target.closest('[data-daile-cz-nfc-toggle]');
      if (nfcT) {
        var on = nfcT.getAttribute('data-daile-cz-nfc-toggle') === 'on';
        if (on !== store.getState().nfc.enabled) {
          store.merge('nfc', { enabled: on });
          track('nfc_selected', { enabled: on });
        }
        return;
      }
      var learn = e.target.closest('[data-daile-cz-nfc-learn]');
      if (learn) { openModal(nfcModal); return; }
      var closeM = e.target.closest('[data-daile-cz-nfc-close]');
      if (closeM) { closeModal(nfcModal); return; }

      var stepBtn = e.target.closest('[data-daile-cz-step]');
      if (stepBtn) {
        var idx = parseInt(stepBtn.getAttribute('data-daile-cz-step'), 10);
        var st = store.getState();
        // только на досягаемые шаги: пройденные И не запертые гейтами (аудит TASK49)
        if (idx <= Math.min(st.maxStepReached, maxAllowedStep(st)) && idx !== st.step) goTo(idx);
      }
    });

    // выбор файла: input (browse/галерея — мобайл сам откроет медиатеку)
    if (fileInput) {
      fileInput.addEventListener('change', function () {
        acceptFile(fileInput.files && fileInput.files[0]);
        // сразу очищаем: повторный выбор ТОГО ЖЕ файла после отказа
        // (blocked/битый) иначе не даёт события change (аудит TASK49)
        fileInput.value = '';
      });
    }

    // drag-and-drop (desktop): и на дроп-зону, и на превью Upload
    function wireDrop(el) {
      if (!el) return;
      el.addEventListener('dragover', function (e) {
        e.preventDefault();
        if (dropzone) dropzone.classList.add('is-over');
      });
      el.addEventListener('dragleave', function () {
        if (dropzone) dropzone.classList.remove('is-over');
      });
      el.addEventListener('drop', function (e) {
        e.preventDefault();
        e.stopPropagation(); // root-страховка ниже не должна обработать повторно
        if (dropzone) dropzone.classList.remove('is-over');
        var dt = e.dataTransfer;
        acceptFile(dt && dt.files && dt.files[0]);
      });
    }
    wireDrop(dropzone);
    wireDrop(stage);

    // аудит TASK49: drop мимо целей = браузер уходит на файл, вся сессия
    // теряется. Гасим дефолт на всём кастомайзере; на шаге Upload — принимаем.
    root.addEventListener('dragover', function (e) { e.preventDefault(); });
    root.addEventListener('drop', function (e) {
      e.preventDefault();
      if (store.getState().step === 0) {
        var dt = e.dataTransfer;
        acceptFile(dt && dt.files && dt.files[0]);
      }
    });

    // zoom-слайдер (100..300 → 1..3): двигаем как жест, коммитим на отпускание
    if (zoomSlider) {
      zoomSlider.addEventListener('input', function () {
        beginGesture();
        live.zoom = Math.min(3, Math.max(1, parseInt(zoomSlider.value, 10) / 100));
        layoutPhoto();
      });
      zoomSlider.addEventListener('change', function () {
        if (gesturing) commitCrop();
      });
    }

    // Шаг Box: текст крышки, размер, NFC URL (TASK46)
    if (textInput) {
      textInput.addEventListener('input', function () {
        store.merge('box', { text: textInput.value });
      });
      var textTracked = false;
      textInput.addEventListener('change', function () {
        if (!textTracked && textInput.value.trim()) { textTracked = true; track('text_added', {}); }
      });
    }
    if (cardInput) {
      cardInput.addEventListener('input', function () {
        store.merge('card', { text: cardInput.value });
      });
      // TASK78 п.3: клик/фокус в заблокированное поле → «подёргать» Add card + подсветить подсказку
      var nudgeAddCard = function () {
        if (store.getState().card.added) return;
        var btn = root.querySelector('[data-daile-cz-card-toggle="on"]');
        var hint = root.querySelector('[data-daile-cz-card-hint]');
        if (btn) {
          btn.classList.remove('is-nudge');
          void btn.offsetWidth; // reflow — анимация перезапускается при повторных кликах
          btn.classList.add('is-nudge');
          btn.addEventListener('animationend', function () { btn.classList.remove('is-nudge'); }, { once: true });
        }
        if (hint) {
          hint.classList.add('is-flash');
          window.setTimeout(function () { hint.classList.remove('is-flash'); }, 1400);
        }
        try { cardInput.blur(); } catch (e) { /* не критично */ }
      };
      cardInput.addEventListener('focus', nudgeAddCard);
      cardInput.addEventListener('click', nudgeAddCard);
    }
    if (nfcUrl) {
      nfcUrl.addEventListener('input', function () {
        store.merge('nfc', { url: nfcUrl.value });
      });
    }
    // модалки (NFC + лайтбокс + confirm): клик по бэкдропу и Esc закрывают
    Array.prototype.forEach.call([nfcModal, lbModal, confirmModal], function (m) {
      if (!m) return;
      m.addEventListener('click', function (e) {
        if (e.target === m) { closeModal(m); if (m === confirmModal) confirmPending = null; }
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      if (nfcModal && !nfcModal.hasAttribute('hidden')) closeModal(nfcModal);
      if (lbModal && !lbModal.hasAttribute('hidden')) closeModal(lbModal);
      if (confirmModal && !confirmModal.hasAttribute('hidden')) { closeModal(confirmModal); confirmPending = null; }
    });

    // ресайз окна → пересчёт раскладки фото и текста крышки (debounce;
    // crop-offsets и размер текста нормализованы — кадр сохраняется)
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { layoutPhoto(); layoutLidText(); layoutCardText(); }, 120);
    });

    // TASK48 (фикс первой загрузки): пока мокап шага не загружен, его canvas
    // имеет нулевую высоту → layoutZone пропускает зону, и при первом переходе
    // фото рендерилось «максимально зазумленным» (без width/height). Любая
    // загрузка картинки внутри canvas → пере-раскладка на следующем кадре.
    var layoutRaf = null;
    function scheduleLayout() {
      if (layoutRaf) return;
      layoutRaf = requestAnimationFrame(function () {
        layoutRaf = null;
        layoutPhoto();
        layoutLidText();
        layoutCardText();
      });
    }
    Array.prototype.forEach.call(root.querySelectorAll('.daile-cz__canvas img'), function (img) {
      img.addEventListener('load', scheduleLayout);
    });

    // TASK59 (вопрос Никиты о «милисекундном» отставании холста при свапе
    // ориентации): фото уже в кэше, а мокап другой ориентации грузится в момент
    // первого свапа. Тёплый прогрев всех вариантов после простоя — свап мгновенный.
    window.setTimeout(function () {
      var warm = [];
      Array.prototype.forEach.call(root.querySelectorAll('[data-daile-cz-mockup], [data-daile-cz-lid]'), function (img) {
        ['data-src-v', 'data-src-h', 'data-src-v-default', 'data-src-h-default', 'data-src-v-nodaile', 'data-src-h-nodaile'].forEach(function (a) {
          var u = img.getAttribute(a);
          if (u && warm.indexOf(u) === -1) {
            warm.push(u);
            var pre = new Image();
            pre.src = u;
          }
        });
      });
    }, 1200);

    initGestures();
    store.subscribe(render);
    render(store.getState()); // первичная отрисовка из initialState

    /* TASK56: режим редактирования (?edit=<_line_id> — ссылка из дровера).
       Дизайн — из _design строки корзины, фото — из IndexedDB; нет блоба
       (другой браузер/устройство) → всё восстановлено, просят перезалить фото. */
    (function bootEdit() {
      var m = /[?&]edit=([^&]+)/.exec(window.location.search);
      if (!m) return;
      var oldId = decodeURIComponent(m[1]);
      try { window.history.replaceState(null, '', window.location.pathname); } catch (e) { /* не критично */ }
      fetch(SHOP_ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var item = null;
          for (var i = 0; i < c.items.length; i++) {
            var p = c.items[i].properties || {};
            if (p._line_id === oldId && p._design) { item = c.items[i]; break; }
          }
          if (!item) return null; // строка уже удалена — обычный новый дизайн
          var d = JSON.parse(item.properties._design);
          editingLineId = oldId;
          store.set({
            orientation: d.orientation === 'h' ? 'h' : 'v',
            crop: d.crop && typeof d.crop.zoom === 'number' ? d.crop : { zoom: 1, nx: 0, ny: 0 },
            box: d.box || store.getState().box,
            card: d.card
              ? { added: true, text: d.card.text || '', font: d.card.font || 'cormorant', sizePreset: d.card.sizePreset || 'l', color: d.card.color || '#161514' }
              : { added: false, text: '', font: 'cormorant', sizePreset: 'l', color: '#161514' },
            nfc: d.nfc ? { enabled: true, url: d.nfc } : { enabled: false, url: '' },
            extras: d.extras || { bag: false, magnets: false, frameInterest: false }
          });
          // TASK61: фото восстанавливаем — сначала локально (IndexedDB, быстро,
          // тот же браузер), иначе из ОБЛАКА по токену из _design (кросс-девайс)
          var pd = d.photo || {};
          function fromCloud() {
            if (!pd.originalUrl) return Promise.resolve(false);
            return fetch(pd.originalUrl)
              .then(function (r) { if (!r.ok) throw new Error('cloud ' + r.status); return r.blob(); })
              .then(function (blob) {
                var t = (blob.type && /^image\//.test(blob.type)) ? blob.type : 'image/jpeg';
                acceptFile(new Blob([blob], { type: t }), true); // АУДИТ TASK62: гарантируем image-MIME
                console.log('[daile-customizer] edit: фото из ОБЛАКА'); return true;
              })
              ['catch'](function (e) { console.warn('[daile-customizer] cloud photo fetch', e); return false; });
          }
          return idbGet('photo_' + oldId).then(function (rec) {
            // TASK58: запись может быть File ЛИБО {buf, type} (fallback-формат)
            var blob = rec && rec.buf ? new Blob([rec.buf], { type: rec.type || 'image/jpeg' }) : rec;
            if (blob) { acceptFile(blob, true); console.log('[daile-customizer] edit: фото из IndexedDB'); return; }
            return fromCloud().then(function (ok) { if (!ok && editNote) editNote.removeAttribute('hidden'); });
          })['catch'](function (e) {
            console.error('[daile-customizer] idb read', e);
            return fromCloud().then(function (ok) { if (!ok && editNote) editNote.removeAttribute('hidden'); });
          });
        })
        .catch(function (e) { console.error('[daile-customizer] edit boot', e); });
    })();

    /* TASK95: фото, загруженное на PDP (daile-pdp.js кладёт его в эту же
       IndexedDB под ключом photo_pdp-pending) — принимаем как обычную загрузку
       (автоориентация, проверка качества, photo_uploaded) и удаляем запись.
       Edit-режим важнее: при ?edit= проброс не трогаем (запись остаётся до
       следующего обычного захода). */
    (function bootPdpPending() {
      if (/[?&]edit=/.test(window.location.search)) return;
      idbGet('photo_pdp-pending').then(function (rec) {
        if (!rec) return;
        var blob = rec && rec.buf ? new Blob([rec.buf], { type: rec.type || 'image/jpeg' }) : rec;
        idbPut('photo_pdp-pending', null)['catch'](function () { /* не критично */ });
        if (blob && blob.type) {
          acceptFile(blob, false);
          console.log('[daile-customizer] фото проброшено с PDP');
        }
      })['catch'](function (e) { console.warn('[daile-customizer] pdp pending read', e); });
    })();

    track('personalizer_started', { size: store.getState().size });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomizer);
  } else {
    initCustomizer();
  }

  // theme editor перевставляет HTML секции при правке настроек — переинициализация
  // (на витрине не срабатывает; аудит TASK49)
  document.addEventListener('shopify:section:load', initCustomizer);
})();
